import React, { useState } from 'react';
import { Collapse } from 'antd';

// Ouvertures retenues par groupe de sections, le temps de la session : passer
// d'un lien à l'autre (ou rouvrir l'éditeur) ne doit pas tout refermer.
const rememberedOpenKeys = {};

const sectionLabelStyle = { fontSize: 12, fontWeight: 600 };
const sectionBodyStyle = { display: 'flex', flexDirection: 'column', gap: 8 };

// Sections repliables du panneau de l'éditeur de forme (Tracé, Extrémités,
// Texte…), même Collapse « ghost » que « Par angle » ou la bibliothèque.
// `sections` : [{ key, title, children, forceRender? }] — `forceRender` garde
// le contenu monté replié (un hôte de portail doit toujours exister).
const ShapePanelSections = ({ groupKey, sections, defaultOpenKeys = [] }) => {
  const [openKeys, setOpenKeys] = useState(() => rememberedOpenKeys[groupKey] ?? defaultOpenKeys);
  const handleChange = (keys) => {
    const next = Array.isArray(keys) ? keys : [keys];
    rememberedOpenKeys[groupKey] = next;
    setOpenKeys(next);
  };
  return (
    <Collapse
      size='small'
      ghost
      activeKey={openKeys}
      onChange={handleChange}
      items={sections.filter(Boolean).map(({ key, title, children, forceRender }) => ({
        key,
        forceRender,
        label: <span style={sectionLabelStyle}>{title}</span>,
        children: <div style={sectionBodyStyle}>{children}</div>,
      }))}
    />
  );
};

export default ShapePanelSections;
